var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "nav_left",
    d: "M5.12556 11.1502L5.12554 11.1502L1.0773 7.09352C1.07724 7.09346 1.07718 7.0934 1.07713 7.09335C0.474265 6.49029 0.474353 5.50974 1.07732 4.90647L5.12556 11.1502ZM5.12556 11.1502C5.42426 11.4495 5.90899 11.45 6.20828 11.1513L5.12556 11.1502ZM6.20943 10.0686L6.20944 10.0686C6.50808 10.3679 6.50762 10.8526 6.20831 11.1513L6.20943 10.0686ZM6.20943 10.0686L2.16062 6.01132L2.16035 6.01104M6.20943 10.0686L2.16035 6.01104M2.16035 6.01104C2.15852 6.00922 2.15768 6.00773 2.15713 6.00638C2.15648 6.00477 2.15599 6.00262 2.15599 6.0001C2.15599 5.99758 2.15648 5.99537 2.15717 5.99368C2.15775 5.99224 2.15867 5.99063 2.16064 5.98866L2.16091 5.98838M2.16035 6.01104L2.16091 5.98838M2.16091 5.98838L6.20943 1.93143L6.20944 1.93142M2.16091 5.98838L6.20944 1.93142M6.20944 1.93142C6.50807 1.63213 6.50762 1.14741 6.20833 0.848717L6.20944 1.93142ZM5.12554 0.849817L1.07759 4.9062L6.20828 0.848666C6.05888 0.699567 5.8625 0.625 5.66748 0.625C5.47186 0.625 5.27502 0.70003 5.12554 0.849813L5.39098 1.11471L5.12554 0.849817Z",
    fill: "#1E3799",
    stroke: "#1E3799",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLeft);
export default __webpack_public_path__ + "static/media/nav_left.b6362116fb1735e84742b0bda02378b5.svg";
export { ForwardRef as ReactComponent };